import sentresLogo from './sentres.svg'
import sportnewsLogo from './sportnews.svg'

export default {
  sentres: sentresLogo,
  sportnews: sportnewsLogo,
}
